import styled from 'styled-components';

export const MobileHistoryRowStyled = styled.div`
    display: flex;
    padding: 16px 0;
    align-items: center;
    border-bottom: 1px solid var(--color-background-secondary);
    cursor: pointer;
`;

export const MobileHistoryRowIconContainerStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    width: 48px;
    height: 48px;
    font-size: 27px;
    position: relative;
`;

export const MobileHistoryRowAmountStyled = styled.div`
    &.negative {
        color: var(--color-white);
    }
    &.positive {
        color: var(--color-positive);
    }
    &.secondary {
        color: var(--color-white-60);
    }
`;
